<template>
	<div class="flex flex-col w-full min-h-(--min-height-custom-mobile) lg:min-h-(--min-height-custom) items-center justify-center gap-12 text-sm md:text-base">
		<!-- First Timer Things to Do Container -->
		<div class="flex flex-col items-center gap-4 w-full">
			<!-- Intro -->
			<div class="flex flex-col items-center gap-2 w-full">
				<h1 class="text-2xl! md:text-4xl! flex justify-center uppercase w-full">
					First Timer Experience
				</h1>
			</div>

			<!-- Times Square -->
			<div class="flex flex-col items-center gap-2">
				<button
					class="text-sm md:text-xl flex justify-center uppercase underline underline-offset-2 transition-all duration-(--default-transition-duration) hover:scale-101 hover:cursor-pointer hover:underline-offset-4"
					@click="openURL('https://www.timessquarenyc.org/')"
				>
					Times Square
				</button>
			</div>

			<!-- Grand Central Station -->
			<div class="flex flex-col items-center gap-2">
				<button
					class="text-sm md:text-xl flex justify-center uppercase underline underline-offset-2 transition-all duration-(--default-transition-duration) hover:scale-101 hover:cursor-pointer hover:underline-offset-4"
					@click="openURL('https://grandcentralterminal.com/')"
				>
					Grand Central Station
				</button>
			</div>

			<!-- Brooklyn Bridge -->
			<div class="flex flex-col items-center gap-2">
				<button
					class="text-sm md:text-xl flex justify-center uppercase underline underline-offset-2 transition-all duration-(--default-transition-duration) hover:scale-101 hover:cursor-pointer hover:underline-offset-4"
					@click="openURL('https://www.tripadvisor.com/Articles-lp65X8YNtHlA-Brooklyn_bridge_walk.html')"
				>
					Brooklyn Bridge
				</button>
			</div>

			<!-- Central Park -->
			<div class="flex flex-col items-center gap-2">
				<button
					class="text-sm md:text-xl flex justify-center uppercase underline underline-offset-2 transition-all duration-(--default-transition-duration) hover:scale-101 hover:cursor-pointer hover:underline-offset-4"
					@click="openURL('https://www.centralparknyc.org')"
				>
					Central Park
				</button>
			</div>

			<!-- Broadway Show -->
			<div class="flex flex-col items-center gap-2">
				<span class="text-sm md:text-xl flex justify-center uppercase underline underline-offset-2 transition-all duration-(--default-transition-duration) hover:scale-101 hover:cursor-pointer hover:underline-offset-4">Broadway Show</span>
			</div>

			<!-- Empire State Building -->
			<div class="flex flex-col items-center gap-2">
				<button
					class="text-sm md:text-xl flex justify-center uppercase underline underline-offset-2 transition-all duration-(--default-transition-duration) hover:scale-101 hover:cursor-pointer hover:underline-offset-4"
					@click="openURL('https://www.esbnyc.com/')"
				>
					Empire State Building
				</button>
			</div>

			<!-- 9/11 Memorial -->
			<div class="flex flex-col items-center gap-2">
				<button
					class="text-sm md:text-xl flex justify-center uppercase underline underline-offset-2 transition-all duration-(--default-transition-duration) hover:scale-101 hover:cursor-pointer hover:underline-offset-4"
					@click="openURL('https://www.911memorial.org/')"
				>
					9/11 Memorial & Museum
				</button>
			</div>

			<!-- Statue of Liberty -->
			<div class="flex flex-col items-center gap-2">
				<button
					class="text-sm md:text-xl flex justify-center uppercase underline underline-offset-2 transition-all duration-(--default-transition-duration) hover:scale-101 hover:cursor-pointer hover:underline-offset-4"
					@click="openURL('https://www.nps.gov/stli/index.htm')"
				>
					Statue of Liberty
				</button>
			</div>

			<!-- Metropolitan Museum of Art -->
			<div class="flex flex-col items-center gap-2">
				<button
					class="text-sm md:text-xl flex justify-center uppercase underline underline-offset-2 transition-all duration-(--default-transition-duration) hover:scale-101 hover:cursor-pointer hover:underline-offset-4"
					@click="openURL('https://www.metmuseum.org/')"
				>
					Metropolitan Museum of Art
				</button>
			</div>

			<!-- NYC Public Library -->
			<div class="flex flex-col items-center gap-2">
				<button
					class="text-sm md:text-xl flex justify-center uppercase underline underline-offset-2 transition-all duration-(--default-transition-duration) hover:scale-101 hover:cursor-pointer hover:underline-offset-4"
					@click="openURL('https://www.nypl.org/')"
				>
					New York Public Library
				</button>
			</div>

			<!-- 5th Avenue & Rockefeller Center -->
			<div class="flex flex-col items-center gap-2">
				<button
					class="text-sm md:text-xl flex justify-center uppercase underline underline-offset-2 transition-all duration-(--default-transition-duration) hover:scale-101 hover:cursor-pointer hover:underline-offset-4"
					@click="openURL('https://www.rockefellercenter.com/')"
				>
					5th Avenue & Rockefeller Center
				</button>
			</div>

			<!-- DUMBO Manhattan Bridge View -->
			<div class="flex flex-col items-center gap-2">
				<button
					class="text-sm md:text-xl flex justify-center uppercase underline underline-offset-2 transition-all duration-(--default-transition-duration) hover:scale-101 hover:cursor-pointer hover:underline-offset-4"
					@click="openURL('https://www.google.com/maps/dir/40.7619965,-73.9922342/DUMBO+Manhattan+Bridge+View,+39-21+Washington+St,+Brooklyn,+NY+11201/@40.7310403,-74.0428626,13z/data=!3m1!4b1!4m9!4m8!1m1!4e1!1m5!1m1!1s0x89c25a31658fd477:0x991b3e313969d387!2m2!1d-73.9895698!2d40.7033165?entry=ttu&g_ep=EgoyMDI2MDYyOS4wIKXMDSoASAFQAw%3D%3D')"
				>
					DUMBO Manhattan Bridge View
				</button>
			</div>

			<!-- NY Stock Exchange -->
			<div class="flex flex-col items-center gap-2">
				<button
					class="text-sm md:text-xl flex justify-center uppercase underline underline-offset-2 transition-all duration-(--default-transition-duration) hover:scale-101 hover:cursor-pointer hover:underline-offset-4"
					@click="openURL('https://www.nyse.com/')"
				>
					New York Stock Exchange and Wall Street
				</button>
			</div>
		</div>

		<!-- Gonzalez Experience Things to Do Container -->
		<div class="flex flex-col items-center gap-12 w-full">
			<!-- Intro -->
			<div class="flex flex-col items-center gap-2 w-full">
				<h1 class="text-2xl! md:text-4xl! flex justify-center uppercase w-full">
					The Gonzalez Experience
				</h1>
				<span class="flex justify-center text-sm! md:text-xl! text-center md:text-start w-full">
					(Brennan and Grant's Favorites)
				</span>
			</div>

			<div class="flex justify-center w-full">
				<!-- Eat / Drink -->
				<div class="flex flex-col w-1/2 items-center gap-2">
					<span class="text-2xl! md:text-4xl! flex w-full justify-center">Eat/Drink</span>
					<span class="text-sm! md:text-xl!">Bocca di Bacco</span>
					<span class="text-sm! md:text-xl!">Il Divino</span>
					<span class="text-sm! md:text-xl!">St Kilda Coffee</span>
					<span class="text-sm! md:text-xl!">Hudson Bagel</span>
					<span class="text-sm! md:text-xl!">Westway Diner</span>
					<span class="text-sm! md:text-xl!">Mountain House</span>
					<span class="text-sm! md:text-xl!">Fornino</span>
				</div>

				<!-- Explore -->
				<div class="flex flex-col w-1/2 items-center gap-2">
					<span class="text-2xl! md:text-4xl! flex w-full justify-center">Explore</span>
					<span class="text-sm! md:text-xl!">The High Line</span>
					<span class="text-sm! md:text-xl!">Yankees/Mets Game</span>
					<span class="text-sm! md:text-xl!">Central Park</span>
					<span class="text-sm! md:text-xl!">The Brooklyn Bridge</span>
					<span class="text-sm! md:text-xl!">Museum of Natural History</span>
					<span class="text-sm! md:text-xl!">Food Tour</span>
				</div>
			</div>
		</div>
	</div>
</template>

<script setup lang="ts">
	import LoadingCard from "~/components/LoadingCard.vue";

	const { ALLOW_API_CALLS } = globalStores();
	const { contentLoaded, thingsToDoPhotos } = imageDataStores();
	const { openURL } = useUtils();

	const getPhotoIndex = ( photoName: string ) => {
		return thingsToDoPhotos.value.find( photo => photo.alt.includes( photoName ) )?.index;
	};
</script>

<style scoped>

</style>